import React from "react"
import { FeaturesSectionWithHoverEffects } from "../common/feature-section-with-hover-effects"
const NodejsServies = () => {
  return (
    <div className="section-py">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12">
          <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
            <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">How Node.js Development Can Reap Benefits for Business?</h2>
          </div>
        </div>
        <div className="row relative">         
            <div className="w-full">
              <FeaturesSectionWithHoverEffects />
            </div>         
        </div>
      </div>
    </div>
  )
}

export default NodejsServies
